import { useNavigate } from 'react-router-dom';
import useCart from '../Cart/useCart';

const useBack = () => {
  const navigate = useNavigate();
  const { returnUrl } = useCart();

  return () => navigate(returnUrl.replace(/^http[s]*:/, ''));
};

export default useBack;
